import styled from 'styled-components';

export const AttrLabel = styled.div`
  width: 140px;
  min-width: 140px;
  color: #262626;
`;

/** Строка одного атрибута в конструкторе. */
export const AttrRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  padding: 6px 0;
`;

/** Контейнер чипсов под селектом. */
export const ChipsRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 6px;
`;
